/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `none` - none
 * `auto` - auto
 */
export type IntroModeEnum = (typeof IntroModeEnum)[keyof typeof IntroModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroModeEnum = {
  none: "none",
  auto: "auto",
} as const;
